<router-outlet></router-outlet>
@if (isBetaWarning) {
  <beta-warning (agreeBetaOutput)="agreeBeta($event)"></beta-warning>
}
